export default function PageHeader({ title, subtitle, children }) {
  return (
    <div className="h-16 px-5 flex items-center justify-between border-b border-slate-200 bg-[#F7F9FB] shrink-0">
      <div>
        <h1 className="font-heading text-xl font-bold leading-none">{title}</h1>
        {subtitle && <p className="text-xs text-slate-500 mt-1">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2">{children}</div>
    </div>
  );
}
